<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>
    <div class="mall_mypageWrap">
      <div class="main_loginWrap" v-if="statusData.searchData.length === 0">
        <h2 class="main_login_tit">{{$route.query.search_status === '1' ? '아이디 찾기' : '비밀번호 찾기'}}</h2>
        <div class="mallMy_nonLogoinBox_box" v-if="$route.query.search_status === '2'">
          <p class="mallMy_nonLogoinBox_subTit">아이디</p>
          <input
            type = "text"
            id = 'customer_login_ID'
            v-model="formData.customerLoginID"
            maxlength="15"
            placeholder="아이디를 입력해주세요"
            @keydown.enter="check_form"
          >
          <p class="main_errorBox">{{errorData.customerLoginIDError}}</p>
        </div>

        <div class="mallMy_nonLogoinBox_box">
          <p class="mallMy_nonLogoinBox_subTit">이름</p>
          <input
            type = "text"
            id = 'customer_name'
            v-model="formData.customerName"
            maxlength="10"
            placeholder="이름을 입력해주세요"
            @keydown.enter="check_form"
          >
          <p class="main_errorBox">{{errorData.customerNameError}}</p>
        </div>

        <div class="mallMy_nonLogoinBox_box">
          <p class="mallMy_nonLogoinBox_subTit">이메일</p>
          <input
            type = "text"
            id = 'customer_email'
            v-model="formData.customerEmail"
            maxlength="50"
            placeholder="이메일을 입력해주세요"
            @keydown.enter="check_form"
          >
          <p class="main_errorBox">{{errorData.customerEmailError}}</p>
        </div>

        <button class="main_loginBtn" v-on:click="check_form">
          확인
        </button>
      </div>

      <!-- 아이디 찾기 성공 시 -->
      <div class="main_loginWrap" v-if="statusData.searchData.length !== 0">
        <div class="main_searchPwBox">
          <p>아이디 찾기가 완료 되었습니다.</p>
          <p>가입된 아이디가 총 {{statusData.searchData.length}}개 있습니다.</p>
        </div>
        <div class="main_searchPw_result">
          <p>아이디 찾기 결과</p>
          <div
            v-for="item in statusData.searchData"
            :key="item.customer_ID"
            class="main_searchPw_resultDiv"
          >
            <p v-if="item.customer_division !== 1">
              {{item.customer_division_name}} ({{item.customer_registe}}, 간편로그인 가입)
            </p>
            <p v-else>
              {{item.customer_login_ID}} ({{item.customer_registe}}, 홈페이지 가입)
            </p>
          </div>
        </div>
        <div class="main_searchPw_resultBtn">
          <a href="/Login">로그인</a>
          <a href="/SearchIdPassword?search_status=2">비밀번호찾기</a>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Spiner from '../Section/Spiner.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validateEmail
} from '../../ETC/Validation.vue'
import {
  search_customer,
  send_temp_password
} from '../../ETC/Axios.vue'

export default {
  name: 'Login',
  components: {
    Header: Header,
    Footer: Footer,
    Spiner: Spiner,
    Scroll
  },
  setup () {
    return {
      formData: ref({
        customerLoginID: '',
        customerName: '',
        customerEmail: ''
      }),
      errorData: ref({
        customerLoginIDError: '',
        customerEmailError: '',
        customerNameError: ''
      }),
      statusData: ref({
        customerLoginIDStatus: false,
        customerEmailStatus: false,
        customerNameStatus: false,
        spinnerStatus: false,
        searchData: []
      })
    }
  },
  watch: {
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerLoginIDError = '아이디는 필수 입력입니다.'
        this.statusData.customerLoginIDStatus = false
      } else if (removeWhitespace(value).length < 5) {
        this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력해야 합니다.'
        this.statusData.customerLoginIDStatus = false
      } else if (validateEngNum(removeWhitespace(value))) {
        this.errorData.customerLoginIDError = ''
        this.statusData.customerLoginIDStatus = true
      } else {
        this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
        this.statusData.customerLoginIDStatus = false
      }
    },
    'formData.customerName': function (value) {
      this.formData.customerName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerNameError = '이름은 필수 입력입니다.'
        this.statusData.customerNameStatus = false
      } else {
        this.errorData.customerNameError = ''
        this.statusData.customerNameStatus = true
      }
    },
    'formData.customerEmail': function (value) {
      this.formData.customerEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerEmailError = '이메일은 필수 입력입니다.'
        this.statusData.customerEmailStatus = false
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.customerEmailError = ''
        this.statusData.customerEmailStatus = true
      } else {
        this.errorData.customerEmailError = '이메일 형식으로 입력하셔야 합니다.'
        this.statusData.customerEmailStatus = false
      }
    }
  },
  methods: {
    check_form: function () {
      if (this.$route.query.search_status === '1') {
        this.statusData.customerLoginIDStatus = true
      }
      if (
        this.statusData.customerLoginIDStatus &&
        this.statusData.customerEmailStatus &&
        this.statusData.customerNameStatus
      ) {
        this.statusData.spinnerStatus = true
        search_customer(
          this.formData.customerLoginID,
          this.formData.customerName,
          this.formData.customerEmail,
          this.$route.query.search_status
        ).then(result => {
          if (result.length === 0) {
            alert('입력하신 정보가 없습니다.')
            this.statusData.spinnerStatus = false
          } else if (this.$route.query.search_status === '1') {
            this.statusData.searchData = result
            this.statusData.spinnerStatus = false
          } else if (this.$route.query.search_status === '2') {
            send_temp_password(
              result[0].customer_ID,
              this.formData.customerEmail
            ).then(result => {
              alert('해당 이메일로 임시비밀번호를 발송하였습니다.')
              this.statusData.spinnerStatus = false
            })
          } else {
            alert('알 수 없는 에러가 발생되었습니다.')
            this.statusData.spinnerStatus = false
          }
        })
      } else {
        alert('입력사항을 확인해주세요.')
        this.statusData.spinnerStatus = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Login/SearchIdPassword.vue